import { MoveSupportConfig } from 'game/core'

export const move_support_config: Array<MoveSupportConfig> = [
    {
        available: 0,
        cooldown: 0,
        energy: 1
    }
]